import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var HomeService = /** @class */ (function () {
    function HomeService(http) {
        this.http = http;
    }
    HomeService.prototype.getImagenesPorTipo = function (tipo) {
        return this.http.get(environment.baseUrl + '/imagenes-pagina/' + tipo);
    };
    HomeService.prototype.getCotizaciones = function () {
        return this.http.get(environment.baseUrl + '/cotizaciones');
    };
    HomeService.prototype.getInfoAgropecuaria = function () {
        return this.http.get(environment.baseUrl + '/info-agropecuaria');
    };
    HomeService.ngInjectableDef = i0.defineInjectable({ factory: function HomeService_Factory() { return new HomeService(i0.inject(i1.HttpClient)); }, token: HomeService, providedIn: "root" });
    return HomeService;
}());
export { HomeService };
